var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"floating-button",attrs:{"to":{ name: _vm.view },"bottom":"","fab":"","fixed":"","right":""}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("add")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }